import { LoyaltyServiceServiceMode } from 'generated/graphql-gateway';

const SERVICE_MODE_MAP: Record<string, LoyaltyServiceServiceMode | undefined> = {
  CURBSIDE: LoyaltyServiceServiceMode.CURBSIDE,
  DELIVERY: LoyaltyServiceServiceMode.DELIVERY,
  CATERING_DELIVERY: LoyaltyServiceServiceMode.DELIVERY,
  DRIVE_THRU: LoyaltyServiceServiceMode.DRIVE_THRU,
  MOBILE_ORDER_DRIVE_THRU: LoyaltyServiceServiceMode.DRIVE_THRU,
  EAT_IN: LoyaltyServiceServiceMode.EAT_IN,
  TABLE_SERVICE: LoyaltyServiceServiceMode.EAT_IN,
  TAKEOUT: LoyaltyServiceServiceMode.TAKEOUT,
  CATERING_PICKUP: LoyaltyServiceServiceMode.TAKEOUT,
};

export const getLoyaltyServiceServiceMode = (serviceMode?: string | null) =>
  serviceMode ? SERVICE_MODE_MAP[serviceMode] : undefined;
